import React, { useState } from "react";
import { HeroSection, HomeInfo } from "./styles.js";
import { useTheme } from "../Theme/ThemeProvider.js";
import MainHeading from "../MainHeading/index.js";
import QrCode from "../QrCode/index.js";
import { infoBlocksBusinessData } from "../../data/InfoBlockData.js";
import ContainerHome from "../HomeInfo/index.js";
import PersonalizedAI from "../PersonalizedAI/index.js";
import SolutionsMobile from "../SolutionsMobile/index.js";
import WhySection from "../WhySection/index.js";

export default function Business() {
  const { isDarkMode } = useTheme();
  const [showQrModal, setShowQrModal] = useState(false);

  const toggleQrModal = () => setShowQrModal((prev) => !prev);
  return (
    <HeroSection isDarkMode={isDarkMode}>
      <MainHeading
        toggleQrModal={toggleQrModal}
        title={
          <>
            Tecnologia para <span className="DescriptionSubtext">Proteger</span>
            , e <span className="DescriptionSubtext">Transformar</span> o seu
            negócio.
          </>
        }
        description="Nós acreditamos que segurança e inovação devem andar juntas. Por isso, oferecemos soluções completas para empresas que querem ir além."
        buttonText="Conheça"
      />
      <HomeInfo>
        <div className="MainRow">
          <div className="TitleHome">
            Tudo o que sua empresa precisa para
            <span className="DescriptionSubtext"> ir além</span>
          </div>
          <ContainerHome
            infoBlocks={infoBlocksBusinessData}
            isDarkMode={isDarkMode}
          />
        </div>
      </HomeInfo>
      <PersonalizedAI
        title={"Automação Inteligente com IA personalizada"}
        description={
          "Nossos agentes de IA são desenvolvidos e treinados com os dados do seu negócio para entregar respostas rápidas, precisas e seguras."
        }
        subtitle={
          "Transforme tarefas repetitivas em decisões automáticas, ganhando tempo e produtividade."
        }
        buttonText={"Quero Inovar"}
      />
      <SolutionsMobile
        title={"Soluções Mobile sob medida"}
        description={
          "Criação completa de aplicativos nativos para Android e iOS, desenvolvidos com foco em performance, segurança e uma experiência de usuário impecável."
        }
        subtitle={
          "Transforme seu serviço, lance seu produto digital e modernize seu empresa com um app sob medida."
        }
        buttonText={"Quero criar meu App"}
      />
      <WhySection/>
      {showQrModal && <QrCode onClose={toggleQrModal} />}
    </HeroSection>
  );
}
